import * as React from "react";

interface ErrorBoundaryProps {
  children?: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  errorMessage: string;
}

// React error boundaries must be class components.
class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, errorMessage: "" };
  }

  static getDerivedStateFromError(error: unknown): ErrorBoundaryState {
    return { hasError: true, errorMessage: error instanceof Error ? error.message : String(error) };
  }

  componentDidCatch(error: unknown, errorInfo: React.ErrorInfo) {
    console.error("Unexpected error in the task pane:", error, errorInfo);
  }

  private handleRetry = () => {
    this.setState({ hasError: false, errorMessage: "" });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: "16px", textAlign: "center" }}>
          <h3 style={{ color: "#001C71" }}>Something went wrong</h3>
          <p style={{ fontSize: "12px", color: "#323130", lineHeight: "1.5" }}>
            An unexpected error occurred while displaying this view. This can happen when the template
            configuration or its filter data could not be loaded.
          </p>
          <p style={{ fontSize: "11px", color: "#605E5C", wordBreak: "break-word" }}>{this.state.errorMessage}</p>
          <button
            onClick={this.handleRetry}
            style={{
              marginTop: "8px",
              padding: "6px 20px",
              borderRadius: "6px",
              border: "0.25pt solid #C4E1E0",
              backgroundColor: "#ffffff",
              color: "#001C71",
              fontSize: "12px",
              cursor: "pointer",
            }}
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
